import { useEffect, useState } from 'react';

export function useMobileHeight() {
  const [height, setHeight] = useState(window.innerHeight);
  const handleHeight = () => {
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener('resize', handleHeight);

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleHeight);
  }, []); // Empty array ensures that effect is only run on mount

  return height;
}
